import { render, staticRenderFns } from "./AM.vue?vue&type=template&id=21af886b"
import script from "./AM.vue?vue&type=script&lang=js"
export * from "./AM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports